export class IWebSocket {
  webSocket: WebSocket | any
  options: TXE_LIVE_SOCKET.PUBLIC_GATE.SocketOptions

  static wsInstance: IWebSocket | any
  GetUrl: any

  constructor(options: TXE_LIVE_SOCKET.PUBLIC_GATE.SocketOptions) {
    this.options = options
    const url = options.url || this.GetUrl()
    const { token } = options
    this.webSocket = new WebSocket(`${url}?token=${token}`)
  }

  static getInstance(
    options?: TXE_LIVE_SOCKET.PUBLIC_GATE.SocketOptions | any,
  ) {
    if (!this.wsInstance) {
      console.log("wsInstance not init")
      if (!options) return
      this.wsInstance = new IWebSocket(options)
      // 连接成功
      this.wsInstance.webSocket.onopen = function (event: any) {
        console.log("ws opened ", event)
        options?.init()
      }
      // 连接异常
      this.wsInstance.webSocket.onclose = function (event: any) {
        console.log("ws error ", event)
      }
    }
    return this.wsInstance
  }

  // 销毁ws单例对象，退房，关闭连接

  static destroyInstance() {
    this.wsInstance?.webSocket?.close()
    this.wsInstance?.clear()
  }

  // 重连
  retry() {
    IWebSocket.wsInstance.webSocket.close()
    this.clear()
    IWebSocket.wsInstance = new IWebSocket(this.options)
  }

  clear() {
    if (IWebSocket.wsInstance) {
      IWebSocket.wsInstance.webSocket = null
      IWebSocket.wsInstance = null
    }
  }

  emit<T extends keyof TXE_LIVE_SOCKET.PUBLIC_GATE.ClientToServerEvents>(
    eventName: T,
    data: any,
  ) {
    if (this.webSocket) {
      if (this.webSocket.readyState === WebSocket.OPEN) {
        return this.webSocket.send(data)
      }
    }
  }

  on<T extends keyof TXE_LIVE_SOCKET.PUBLIC_GATE.ServerToClientEvents>(
    eventName: T,
    callback: (data: any) => void,
  ) {
    if (this.webSocket) {
      this.webSocket.onmessage = function (event: any) {
        callback(event.data)
      }
    }
  }
}
